const CREATOR_HANDLE_PREFIX = "@";

/** Formats a creator username as a handle (`@name`) for card chrome. */
const formatDiscoverChatbotCardCreatorHandle = (creatorUsername: string | undefined): string | undefined => {
  if (!creatorUsername) {
    return undefined;
  }

  return `${CREATOR_HANDLE_PREFIX}${creatorUsername}`;
};

export default formatDiscoverChatbotCardCreatorHandle;
